import './App.css';
import { Routes, Route, useLocation } from "react-router-dom";
// import Home from './Pages/Home';
import ScrollToTop from './Components/ScrollToTop';
import FAQ from './Pages/Faq';
import AiServices from './Pages/AIServices/AiServices';
import TermsConditions from './Pages/TermsConditions';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import { ToastContainer } from 'react-toastify';
import { HelmetProvider } from "react-helmet-async";
import DemoHeader from './Components/header/DemoHeader';
import DemoFooter from './Components/footer/DemoFooter';
import Home3 from './Pages/Home3';
import ServiceDemo from './Pages/ServiceDemo';
import CareerDummy from './Pages/CareerDummy';
import NewAI from './Pages/services/NewAI';
import NewIndustries from './Pages/NewIndustries';
import ContactDummy from './Pages/ContactDummy';
import GlodeskDummy from './Pages/GlodeskDummy';
import HireDummy from './Pages/HireDummy';
import AllOpenings from './Pages/AllOpenings';
import CloudEngineering from './Pages/services/CloudEngineering';
import DataAnalytics from './Pages/services/DataAnalytics';
import GloKodeDummy from './Pages/GloKodeDummy';
import ProductEngineering from './Pages/services/ProductEngineering';
import AgenticAI from './Pages/services/AgenticAI';
import PerformanceEngineering from './Pages/services/PerformanceEngineering';
import ConsultingService from './Pages/services/ConsultingService';
import InForService from './Pages/services/InForService';
import InforEPMServices from './Pages/services/InforEPMServices';
import ManufacturingExecutionSystem from './Pages/services/Manufacturing-Execution-System';
import IndustrialAutomation from './Pages/services/IndustrialAutomation';
import BMSSolutions from './Pages/services/BMSSoluction';
import GlobalCapability from './Pages/services/GlobalCapability';
import StaffAugmentationService from './Pages/services/StaffAugmentationService';
import EmbeddedSoftware from './Pages/services/EmbeddedSoftware';
import WhoWeAre from './Pages/WhoWeAre';
import AIIntelligentAutomation from './Pages/Capabilities/AIIntelligentAutomation';
import EnterpriseApplicationsERP from './Pages/Capabilities/EnterpriseApplicationsERP';
import ServiceNowDigitalWorkflows from './Pages/Capabilities/ServiceNowDigitalWorkflows';
import CloudDevOpsEngineering from './Pages/Capabilities/CloudDevOpsEngineering';
import EmbeddedSystemsIndustrial from './Pages/Capabilities/EmbeddedSystemsIndustrial';
import ProductEngineeringDigital from './Pages/Capabilities/ProductEngineeringDigital';
import QualityEngineeringPerformance from './Pages/Capabilities/QualityEngineeringPerformance';
import ManagedServices from './Pages/Capabilities/ManagedServices';
import Capability from './Pages/Capability';
import BlogPage from './Pages/BlogPage';
import BlogDetail from './Pages/BlogDetail';
import HealthcareIndustryDetail from './Pages/HealthcareIndustryDetail';
import BFSIIndustryDetail from './Pages/BFSIIndustryDetail';
import SalesServices from './Pages/SalesServices';
import OurLeadership from './Pages/OurLeadership';
import OurFounder from './Pages/OurFounder';
import SalesServicesOverview from './Pages/SalesServicesOverview';
import Products from './Pages/Products';
import WorkingHere from './Pages/WorkingHere';
import Benefits from './Pages/Benefits';
import WorkEnvironment from './Pages/WorkEnvironment';
import News from './Pages/News';
import Awards from './Pages/Awards';
import Recruiting from './Pages/Recruiting';
import Lab from './Pages/Lab';
import JobApply from './Pages/JobApply';
import Sustainability from './Pages/Sustainability';
import Customer from './Pages/Customer';
import Diversity from './Pages/Diversity';
import Insights from './Pages/Insights';
import InsightsDetail from './Pages/InsightsDetail';
import CaseStudies from './Pages/CaseStudies';
import CaseStudiesDetail from './Pages/CaseStudiesDetail';
import Analyst from './Pages/Analyst';
import AnalystDetail from './Pages/AnalystDetail';
import GlobalPresence from './Pages/GlobalPresence';
import OurEsg from './Pages/OurEsg';
import DiversityInclusion from './Pages/DiversityInclusion';
import Leverage from './Pages/Leverage';
import Transforming from './Pages/Transforming';
import Hospital from './Pages/Hospital';
import Hrms from './Pages/Hrms';
import DataExtraction from './Pages/DataExtraction';
import Mumbai from './Pages/location/Mumbai';
import Bangalore from './Pages/location/Bangalore';
import Pune from './Pages/location/Pune';
import Hyderabad from './Pages/location/Hyderabad';
import Delhi from './Pages/location/Delhi';
import Gurugram from './Pages/location/Gurugram';
import Belgium from './Pages/location/Belgium';
import Croatia from './Pages/location/Croatia';
import Denmark from './Pages/location/Denmark';
import Finland from './Pages/location/Finland';
import France from './Pages/location/France';
import Germany from './Pages/location/Germany';
import Greece from './Pages/location/Greece';
import Hungary from './Pages/location/Hungary';
import Italy from './Pages/location/Italy';
import Luxembourg from './Pages/location/Luxembourg';
import Monaco from './Pages/location/Monaco';
import Netherlands from './Pages/location/Netherlands';
import Spain from './Pages/location/Spain';
import Sweden from './Pages/location/Sweden';
import Switzerland from './Pages/location/Switzerland';
import Dubai from './Pages/location/Dubai';
import Sharjah from './Pages/location/Sharjah';
import AbuDhabi from './Pages/location/AbuDhabi';
import SaudiArabia from './Pages/location/SaudiArabia';
import NewYork from './Pages/location/NewYork';
import California from './Pages/location/California';
import Melbourne from './Pages/location/Melbourne';
import Home4 from './Pages/Home4';
import Chennai from './Pages/location/Chennai';
import Gurgaon from './Pages/location/Gurgaon';
import Washington from './Pages/location/Washington';
import Dallas from './Pages/location/Dallas';
import Houston from './Pages/location/Houston';
import Charlotte from './Pages/location/Charlotte';
import Chicago from './Pages/location/Chicago';
import Atlanta from './Pages/location/Atlanta';
import Phoenix from './Pages/location/Phoenix';
import Boston from './Pages/location/Boston';
import Austin from './Pages/location/Austin';
import Philadelphia from './Pages/location/Philadelphia';
import Detroit from './Pages/location/Detroit';
import Qatar from './Pages/location/Qatar';
import Kuwait from './Pages/location/Kuwait';
import Consulting from './Pages/service/Consulting';
import Services from './Pages/Services';
import Servicex from './Pages/solutions/Servicex';
import IntelligentOperations from './Pages/solutions/IntelligentOperations';
import ResilientSecurity from './Pages/solutions/ResilientSecurity';
import Innovation from './Pages/solutions/Innovation';
import IndustrialEdge from './Pages/solutions/IndustrialEdge';
import SourceToPay from './Pages/solutions/SourceToPay';
import AutomationEngine from './Pages/solutions/AutomationEngine';
import Automation from './Pages/solutions/Automation';
import ServicenowAi from './Pages/solutions/ServicenowAi';
import CSDM from './Pages/solutions/CSDM';
import ServiceManagement from './Pages/solutions/ServiceManagement';
import ImplementationPartner from './Pages/solutions/ImplementationPartner';
import Clients from './Pages/Clients';
import ServicenowCOE from './Pages/ServicenowCOE';
import ServiceNowStaffAugmentation from './Pages/ServiceNowStaffAugmentation';
import HireServicenowDevelopers from './Pages/HireServicenowDevelopers';
import ServiceNowImplementationPartner from './Pages/ServiceNowImplementationPartner';
import ServiceNowManagedServices from './Pages/ServiceNowManagedServices';
import ServiceNowConsultingCompany from './Pages/ServiceNowConsultingCompany';
import DedicatedServiceNowTeam from './Pages/DedicatedServiceNowTeam';
import ServiceNowLinks from './Pages/ServiceNowLinks';
import HireServicenowDevelopersAustin from './Pages/HireServicenowDevelopersAustin';
import HireServicenowDevelopersNewYork from './Pages/HireServicenowDevelopersNewYork';
import HireServicenowDevelopersChicago from './Pages/HireServicenowDevelopersChicago';
import HireServicenowDevelopersLosAngeles from './Pages/HireServicenowDevelopersLosAngeles';
import HireServicenowDevelopersSanFrancisco from './Pages/HireServicenowDevelopersSanFrancisco';
import HireServicenowDevelopersBoston from './Pages/HireServicenowDevelopersBoston';

import HireServicenowDevelopersDallas from './Pages/HireServicenowDevelopersDallas';
import HireServicenowDevelopersWashingtonDC from './Pages/HireServicenowDevelopersWashingtonDC';
import HireServicenowDevelopersAtlanta from './Pages/HireServicenowDevelopersAtlanta';
import HireServicenowDevelopersPhoenix from './Pages/HireServicenowDevelopersPhoenix';
import HireServicenowDevelopersLondon from './Pages/HireServicenowDevelopersLondon';
import HireServicenowDevelopersManchester from './Pages/HireServicenowDevelopersManchester';
import HireServicenowDevelopersBirmingham from './Pages/HireServicenowDevelopersBirmingham';
import HireServicenowDevelopersLeeds from './Pages/HireServicenowDevelopersLeeds';
import HireServicenowDevelopersEdinburgh from './Pages/HireServicenowDevelopersEdinburgh';
import HireServicenowDevelopersGlasgow from './Pages/HireServicenowDevelopersGlasgow';
import HireServicenowDevelopersBristol from './Pages/HireServicenowDevelopersBristol';
import HireServicenowDevelopersLiverpool from './Pages/HireServicenowDevelopersLiverpool';
import HireServicenowDevelopersCambridge from './Pages/HireServicenowDevelopersCambridge';
import HireServicenowDevelopersDubai from './Pages/HireServicenowDevelopersDubai';
import HireServicenowDevelopersAbuDhabi from './Pages/HireServicenowDevelopersAbuDhabi';
import HireServicenowDevelopersSharjah from './Pages/HireServicenowDevelopersSharjah';
import HireServicenowDevelopersAjman from './Pages/HireServicenowDevelopersAjman';
import HireServicenowDevelopersRasAlKhaimah from './Pages/HireServicenowDevelopersRasAlKhaimah';
import HireServicenowDevelopersFujairah from './Pages/HireServicenowDevelopersFujairah';
import DatabricksConsulting from './Pages/Databricks/DatabricksConsulting';
import LakehouseArchitecture from './Pages/Databricks/LakehouseArchitecture';
import DataEngineering from './Pages/Databricks/DataEngineering';
import GenAIAgents from './Pages/Databricks/GenAIAgents';
import DatabricksAnalyticsBI from './Pages/Databricks/DatabricksAnalyticsBI';
import DatabricksManagedServices from './Pages/Databricks/DatabricksManagedServices';
import DatabricksServices from './Pages/DatabricksServices';
import HireDatabricksConsultantAustin from './Pages/HireDatabricksConsultantAustin';
import ConversationalAI from './Pages/services/ConversationalAI';
import MachineLearningMLOps from './Pages/services/MachineLearningMLOps';
import GenerativeAI from './Pages/services/GenerativeAI';
import CookieConsent from './Components/CookieConsent';
import HireDatabricksConsultantMumbai from './Pages/HireDatabricksConsultantMumbai';
import HireDatabricksConsultantBangalore from './Pages/HireDatabricksConsultantBangalore';
import HireDatabricksConsultantPune from './Pages/HireDatabricksConsultantPune';
import HireDatabricksConsultantHyderabad from './Pages/HireDatabricksConsultantHyderabad';
import HireDatabricksConsultantDelhi from './Pages/HireDatabricksConsultantDelhi';
import HireDatabricksConsultantGurugram from './Pages/HireDatabricksConsultantGurugram';
import HireDatabricksConsultantChennai from './Pages/HireDatabricksConsultantChennai';
import HireDatabricksConsultantGurgaon from './Pages/HireDatabricksConsultantGurgaon';
import HireDatabricksConsultantBelgium from './Pages/HireDatabricksConsultantBelgium';
import HireDatabricksConsultantCroatia from './Pages/HireDatabricksConsultantCroatia';
import HireDatabricksConsultantDenmark from './Pages/HireDatabricksConsultantDenmark';
import HireDatabricksConsultantFinland from './Pages/HireDatabricksConsultantFinland';
import HireDatabricksConsultantFrance from './Pages/HireDatabricksConsultantFrance';
import HireDatabricksConsultantGermany from './Pages/HireDatabricksConsultantGermany';
import HireDatabricksConsultantGreece from './Pages/HireDatabricksConsultantGreece';
import HireDatabricksConsultantHungary from './Pages/HireDatabricksConsultantHungary';
import HireDatabricksConsultantItaly from './Pages/HireDatabricksConsultantItaly';
import HireDatabricksConsultantDubai from './Pages/HireDatabricksConsultantDubai';
import HireDatabricksConsultantSharjah from './Pages/HireDatabricksConsultantSharjah';
import HireDatabricksConsultantAbuDhabi from './Pages/HireDatabricksConsultantAbuDhabi';
import HireDatabricksConsultantSaudiArabia from './Pages/HireDatabricksConsultantSaudiArabia';
import HireDatabricksConsultantQatar from './Pages/HireDatabricksConsultantQatar';
import HireDatabricksConsultantKuwait from './Pages/HireDatabricksConsultantKuwait';
import HireDatabricksConsultantMelbourne from './Pages/HireDatabricksConsultantMelbourne';
import HireDatabricksConsultantNewYork from './Pages/HireDatabricksConsultantNewYork';
import HireDatabricksConsultantCalifornia from './Pages/HireDatabricksConsultantCalifornia';
import HireDatabricksConsultantWashingtonDC from './Pages/HireDatabricksConsultantWashingtonDC';
import HireDatabricksConsultantDallas from './Pages/HireDatabricksConsultantDallas';
import HireDatabricksConsultantHouston from './Pages/HireDatabricksConsultantHouston';
import HireDatabricksConsultantCharlotte from './Pages/HireDatabricksConsultantCharlotte';
import HireDatabricksConsultantChicago from './Pages/HireDatabricksConsultantChicago';
import HireDatabricksConsultantAtlanta from './Pages/HireDatabricksConsultantAtlanta';
import HireDatabricksConsultantPhoenix from './Pages/HireDatabricksConsultantPhoenix';
import HireDatabricksConsultantBoston from './Pages/HireDatabricksConsultantBoston';
import HireDatabricksConsultantPhiladelphia from './Pages/HireDatabricksConsultantPhiladelphia';
import HireDatabricksConsultantDetroit from './Pages/HireDatabricksConsultantDetroit';
import AutomationPage from './Pages/AutomationPage';
import DataAiDatabricks from './Pages/DataAiDatabricks';
import DigitalEngineering from './Pages/DigitalEngineering';
import NewFooter from './Components/footer/NewFooter';
import Disclaimer from './Pages/Disclaimer';



function App() {
  const location = useLocation();
  const hideHeaderFooterRoutes = ['/test-home'];
  const shouldHideHeaderFooter = hideHeaderFooterRoutes.includes(location.pathname);
  return (
    <>
      <HelmetProvider>
        <ToastContainer />
        <ScrollToTop />
        {!shouldHideHeaderFooter && <DemoHeader />}
        <Routes>
          <Route path="/" element={<Home3 />} />
          <Route path="/test-home" element={<Home4 />} />
          {/* <Route path="/" element={<HomeDev />} /> */}
          <Route path="/what-we-do" element={<ServiceDemo />} />
          <Route path="/capabilities" element={<Capability />} />
          <Route path="/blogs" element={<BlogPage />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/careers" element={<CareerDummy />} />
          <Route path="/all-openings" element={<AllOpenings />} />
          <Route path="/industries" element={<NewIndustries />} />
          <Route path="/industries/:id" element={<HealthcareIndustryDetail />} />
          <Route path="/industries/bsfi-industry-detail" element={<BFSIIndustryDetail />} />
          <Route path="/contact" element={<ContactDummy />} />
          <Route path="/ai-automation" element={<NewAI />} />
          <Route path="/cloud-engineering" element={<CloudEngineering />} />
          <Route path="/data-analytics" element={<DataAnalytics />} />
          <Route path="/performance-engineering" element={<PerformanceEngineering />} />
          <Route path="/servicenow-consulting" element={<ConsultingService />} />
          <Route path="/servicenow-coe" element={<ServicenowCOE />} />

          {/* {Capabilities} */}
          <Route path="/capabilities/ai-automation" element={<AIIntelligentAutomation />} />
          <Route path="/capabilities/enterprise-applications" element={<EnterpriseApplicationsERP />} />
          <Route path="/capabilities/digital-workflows" element={<ServiceNowDigitalWorkflows />} />
          <Route path="/capabilities/cloud-engineering" element={<CloudDevOpsEngineering />} />
          <Route path="/capabilities/industrial-engineering" element={<EmbeddedSystemsIndustrial />} />
          <Route path="/capabilities/product-engineering" element={<ProductEngineeringDigital />} />
          <Route path="/capabilities/quality-engineering" element={<QualityEngineeringPerformance />} />
          <Route path="/capabilities/managed-services" element={<ManagedServices />} />
          {/* {Capabilities} */}

          <Route path="/infor-m3-solutions" element={<InForService />} />
          <Route path="/infor-epm-services" element={<InforEPMServices />} />
          <Route path="/manufacturing-execution-system" element={<ManufacturingExecutionSystem />} />
          <Route path="/building-automation-solutions" element={<BMSSolutions />} />
          <Route path="/global-capability-centers" element={<GlobalCapability />} />
          <Route path="/staff-augmentation" element={<StaffAugmentationService />} />
          <Route path="/embedded-services" element={<EmbeddedSoftware />} />
          <Route path="/industrial-automation" element={<IndustrialAutomation />} />
          <Route path="/product-engineering" element={<ProductEngineering />} />
          <Route path="/agentic-ai-services" element={<AgenticAI />} />
          <Route path="/glodesk" element={<GlodeskDummy />} />
          <Route path="/glokode" element={<GloKodeDummy />} />
          <Route path="/hire-a-developer" element={<HireDummy />} />
          <Route path="/who-we-are" element={<WhoWeAre />} />
          <Route path="/locations-servicenow" element={<SalesServicesOverview />} />
          <Route path="/:slug" element={<SalesServices />} />
          <Route path="/founders-message" element={<OurFounder />} />
          <Route path="/products" element={<Products />} />
          <Route path="/working-here" element={<WorkingHere />} />
          <Route path="/benefits" element={<Benefits />} />
          <Route path="/work-environment" element={<WorkEnvironment />} />
          <Route path="/news-media" element={<News />} />
          <Route path="/awards-recognition" element={<Awards />} />
          <Route path="/recruiting" element={<Recruiting />} />
          <Route path="/lab" element={<Lab />} />
          <Route path="/sustainability" element={<Sustainability />} />
          <Route path="/customer-speak" element={<Customer />} />
          <Route path="/diversity" element={<Diversity />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insight/:id" element={<InsightsDetail />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/case-studies/:id" element={<CaseStudiesDetail />} />
          <Route path="/analyst-insights" element={<Analyst />} />
          <Route path="/analyst-insights/:id" element={<AnalystDetail />} />
          <Route path="/global-capability" element={<GlobalPresence />} />
          <Route path="/our-esg" element={<OurEsg />} />
          <Route path="/diversity-inclusion" element={<DiversityInclusion />} />
          <Route path="/service-now-consulting" element={<Leverage />} />
          <Route path="/transforming-ideas" element={<Transforming />} />
          <Route path="/hospital-management" element={<Hospital />} />
          <Route path="/hrms-corporate" element={<Hrms />} />
          <Route path="/data-extraction-analytics" element={<DataExtraction />} />
          <Route path="/servicenow" element={<Services />} />
          <Route path="/service/:id" element={<Consulting />} />

          {/* <Route path="/who-we-are" element={<AboutUs />} /> */}
          {/* <Route path="/who-we-are" element={<Services />} /> */}
          {/* <Route path="/ai-automation" element={<AiServices />} /> */}
          {/* <Route path="/glokode" element={<Glocode />} />
          <Route path="/glodesk" element={<Glodesk />} /> */}

          {/* <Route path="/agentic-ai-services" element={<AgenticAIServices />} /> */}
          {/* <Route path="/careers" element={<Career />} /> */}
          <Route path="/faq" element={<FAQ />} />
          {/* <Route path="/contact" element={<ContactUs />} /> */}
          <Route path="/careers-apply/:id" element={<JobApply />} />
          <Route path="/terms-condition" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          {/* <Route path="/cloud-engineering" element={<ServiceDetail />} /> */}
          {/* <Route path="/product-engineering" element={<ProductServices />} /> */}
          {/* <Route path="/performance-engineering" element={<PerformanceEngineeringServices />} /> */}
          {/* <Route path="/building-automation-solutions" element={<BuildingAutomationSolutions />} /> */}
          {/* <Route path="/infor-epm-services" element={<InforEPM />} /> */}
          {/* <Route path="/global-capability" element={<GCC />} /> */}
          {/* <Route path="/staff-augmentation" element={<StaffAugmentation />} /> */}
          {/* <Route path="/data-analytics" element={<AnalyticsService />} /> */}

          {/* State Pages */}
          <Route path="/location/leverage-serviceNow-consulting-in-mumbai" element={<Mumbai />} />
          <Route path="/location/leverage-serviceNow-consulting-in-bangalore" element={<Bangalore />} />
          <Route path="/location/leverage-serviceNow-consulting-in-pune" element={<Pune />} />
          <Route path="/location/leverage-serviceNow-consulting-in-hyderabad" element={<Hyderabad />} />
          <Route path="/location/leverage-serviceNow-consulting-in-delhi" element={<Delhi />} />
          <Route path="/location/leverage-serviceNow-consulting-in-gurugram" element={<Gurugram />} />
          <Route path="/location/leverage-serviceNow-consulting-in-belgium" element={<Belgium />} />
          <Route path="/location/leverage-serviceNow-consulting-in-croatia" element={<Croatia />} />
          <Route path="/location/leverage-serviceNow-consulting-in-denmark" element={<Denmark />} />
          <Route path="/location/leverage-serviceNow-consulting-in-finland" element={<Finland />} />
          <Route path="/location/leverage-serviceNow-consulting-in-france" element={<France />} />
          <Route path="/location/leverage-serviceNow-consulting-in-germany" element={<Germany />} />
          <Route path="/location/leverage-serviceNow-consulting-in-greece" element={<Greece />} />
          <Route path="/location/leverage-serviceNow-consulting-in-hungary" element={<Hungary />} />
          <Route path="/location/leverage-serviceNow-consulting-in-italy" element={<Italy />} />
          <Route path="/location/leverage-serviceNow-consulting-in-luxembourg" element={<Luxembourg />} />
          <Route path="/location/leverage-serviceNow-consulting-in-monaco" element={<Monaco />} />
          <Route path="/location/leverage-serviceNow-consulting-in-netherlands" element={<Netherlands />} />
          <Route path="/location/leverage-serviceNow-consulting-in-spain" element={<Spain />} />
          <Route path="/location/leverage-serviceNow-consulting-in-sweden" element={<Sweden />} />
          <Route path="/location/leverage-serviceNow-consulting-in-switzerland" element={<Switzerland />} />
          <Route path="/location/leverage-serviceNow-consulting-in-chennai" element={<Chennai />} />
          <Route path="/location/leverage-serviceNow-consulting-in-dubai" element={<Dubai />} />
          <Route path="/location/leverage-serviceNow-consulting-in-sharjah" element={<Sharjah />} />
          <Route path="/location/leverage-serviceNow-consulting-in-abu-dhabi" element={<AbuDhabi />} />
          <Route path="/location/leverage-serviceNow-consulting-in-saudi-arabia" element={<SaudiArabia />} />
          <Route path="/location/leverage-serviceNow-consulting-in-new-york" element={<NewYork />} />
          <Route path="/location/leverage-serviceNow-consulting-in-california" element={<California />} />
          <Route path="/location/leverage-serviceNow-consulting-in-melbourne" element={<Melbourne />} />
          <Route path="/location/leverage-serviceNow-consulting-in-gurgaon" element={<Gurgaon />} />
          <Route path="/location/leverage-serviceNow-consulting-in-washington-dc" element={<Washington />} />
          <Route path="/location/leverage-serviceNow-consulting-in-dallas" element={<Dallas />} />
          <Route path="/location/leverage-serviceNow-consulting-in-houston" element={<Houston />} />
          <Route path="/location/leverage-serviceNow-consulting-in-charlotte" element={<Charlotte />} />
          <Route path="/location/leverage-serviceNow-consulting-in-chicago" element={<Chicago />} />
          <Route path="/location/leverage-serviceNow-consulting-in-atlanta" element={<Atlanta />} />
          <Route path="/location/leverage-serviceNow-consulting-in-phoenix" element={<Phoenix />} />
          <Route path="/location/leverage-serviceNow-consulting-in-boston" element={<Boston />} />
          <Route path="/location/leverage-serviceNow-consulting-in-austin" element={<Austin />} />
          <Route path="/location/leverage-serviceNow-consulting-in-philadelphia" element={<Philadelphia />} />
          <Route path="/location/leverage-serviceNow-consulting-in-detroit" element={<Detroit />} />
          <Route path="/location/leverage-serviceNow-consulting-in-qatar" element={<Qatar />} />
          <Route path="/location/leverage-serviceNow-consulting-in-kuwait" element={<Kuwait />} />

          <Route path="/solutions/servicex" element={<Servicex />} />
          <Route path="/solutions/intelligent-operations" element={<IntelligentOperations />} />
          <Route path="/solutions/risk-and-security" element={<ResilientSecurity />} />
          <Route path="/solutions/innovation" element={<Innovation />} />
          <Route path="/solutions/industrial-edge" element={<IndustrialEdge />} />
          <Route path="/solutions/servicenow-source-to-pay" element={<SourceToPay />} />
          <Route path="/solutions/servicenow-automation-engine" element={<AutomationEngine />} />
          <Route path="/solutions/servicenow-automation" element={<Automation />} />
          <Route path="/solutions/servicenow-ai" element={<ServicenowAi />} />
          <Route path="/solutions/servicenow-csdm" element={<CSDM />} />
          <Route path="/solutions/enterprise-service-management" element={<ServiceManagement />} />
          <Route path="/solutions/project-portfolio-management" element={<ImplementationPartner />} />
          <Route path="/clients" element={<Clients />} />


          <Route path="/servicenow-staff-augmentation" element={<ServiceNowStaffAugmentation />} />
          <Route path="/hire-servicenow-developers" element={<HireServicenowDevelopers />} />
          <Route path="/servicenow-implementation-partner" element={<ServiceNowImplementationPartner />} />
          <Route path="/servicenow-managed-services" element={<ServiceNowManagedServices />} />
          <Route path="/servicenow-consulting-company" element={<ServiceNowConsultingCompany />} />
          <Route path="/dedicated-servicenow-team" element={<DedicatedServiceNowTeam />} />
          <Route path="/automation-and-ai-agents/:slug" element={<ConversationalAI />} />
          <Route path="/machine-learning-mlops" element={<MachineLearningMLOps />} />
          <Route path="/generative-ai-llm" element={<GenerativeAI />} />





          <Route
            path="/hire-servicenow-developers-in-austin/"
            element={<HireServicenowDevelopersAustin />}
          />

          <Route
            path="/hire-servicenow-developers-in-new-york/"
            element={<HireServicenowDevelopersNewYork />}
          />

          <Route
            path="/hire-servicenow-developers-in-chicago/"
            element={<HireServicenowDevelopersChicago />}
          />

          <Route
            path="/hire-servicenow-developers-in-los-angeles/"
            element={<HireServicenowDevelopersLosAngeles />}
          />

          <Route
            path="/hire-servicenow-developers-in-san-francisco/"
            element={<HireServicenowDevelopersSanFrancisco />}
          />

          <Route
            path="/hire-servicenow-developers-in-boston/"
            element={<HireServicenowDevelopersBoston />}
          />



          <Route
            path="/hire-servicenow-developers-in-dallas/"
            element={<HireServicenowDevelopersDallas />}
          />

          <Route
            path="/hire-servicenow-developers-in-washington-dc/"
            element={<HireServicenowDevelopersWashingtonDC />}
          />

          <Route
            path="/hire-servicenow-developers-in-atlanta/"
            element={<HireServicenowDevelopersAtlanta />}
          />

          <Route
            path="/hire-servicenow-developers-in-phoenix/"
            element={<HireServicenowDevelopersPhoenix />}
          />
          <Route
            path="/hire-servicenow-developers-in-phoenix/"
            element={<HireServicenowDevelopersPhoenix />}
          />




          <Route
            path="/hire-servicenow-developers-in-London"
            element={<HireServicenowDevelopersLondon />}
          />




          <Route
            path="/hire-servicenow-developers-in-manchester"
            element={<HireServicenowDevelopersManchester />}
          />

          <Route
            path="/hire-servicenow-developers-in-Birmingham"
            element={<HireServicenowDevelopersBirmingham />}
          />



          <Route
            path="/hire-servicenow-developers-in-leeds"
            element={<HireServicenowDevelopersLeeds />}
          />

          <Route
            path="/hire-servicenow-developers-in-edinburgh"
            element={<HireServicenowDevelopersEdinburgh />}
          />



          <Route
            path="/hire-servicenow-developers-in-glasgow"
            element={<HireServicenowDevelopersGlasgow />}
          />


          <Route
            path="/hire-servicenow-developers-in-bristol"
            element={<HireServicenowDevelopersBristol />}
          />

          <Route
            path="/hire-servicenow-developers-in-liverpool"
            element={<HireServicenowDevelopersLiverpool />}
          />

          <Route
            path="/hire-servicenow-developers-in-cambridge"
            element={<HireServicenowDevelopersCambridge />}
          />

          <Route
            path="/hire-servicenow-developers-in-dubai"
            element={<HireServicenowDevelopersDubai />}
          />

          <Route
            path="/hire-servicenow-developers-in-abu-dhabi"
            element={<HireServicenowDevelopersAbuDhabi />}
          />
          <Route
            path="/hire-servicenow-developers-in-sharjah"
            element={<HireServicenowDevelopersSharjah />}
          />

          <Route
            path="/hire-servicenow-developers-in-ajman"
            element={<HireServicenowDevelopersAjman />}
          />
          <Route
            path="/hire-servicenow-developers-in-ras-al-khaimah"
            element={<HireServicenowDevelopersRasAlKhaimah />}
          />

          <Route
            path="/hire-servicenow-developers-in-ras-al-fujairah"
            element={<HireServicenowDevelopersFujairah />}
          />








          {/* <Route
  path="/data-ai-databricks-solutions/databricks-consulting"
  element={<DatabricksConsulting />}
/>
<Route
  path="/data-ai-databricks-solutions/lakehouse-architecture"
  element={<LakehouseArchitecture />}
/>
<Route
  path="/data-ai-databricks-solutions/data-engineering"
  element={<DataEngineering />}
/>
<Route
  path="/data-ai-databricks-solutions/generative-ai-agent-bricks"
  element={<GenAIAgents />}
/>
<Route
  path="/data-ai-databricks-solutions/databricks-sql-bi"
  element={<DatabricksAnalyticsBI />}
/>
<Route
  path="/data-ai-databricks-solutions/databricks-managed-services"
  element={<DatabricksManagedServices />}
/> */}
          <Route path="/data-ai-databricks-solutions" element={<DatabricksServices />} />

          <Route
            path="/data-ai-databricks-solutions/:slug"
            element={<DatabricksConsulting />}
          />

          <Route
            path="/hire-databricks-consultant-austin"
            element={<HireDatabricksConsultantAustin />}
          />

          <Route
            path="/hire-databricks-consultant-mumbai"
            element={<HireDatabricksConsultantMumbai />}
          />


          <Route
            path="/hire-databricks-consultant-bangalore"
            element={<HireDatabricksConsultantBangalore />}
          />
          <Route
            path="/hire-databricks-consultant-pune"
            element={<HireDatabricksConsultantPune />}
          />
          <Route
            path="/hire-databricks-consultant-hyderabad"
            element={<HireDatabricksConsultantHyderabad />}
          />

          <Route
            path="/hire-databricks-consultant-delhi"
            element={<HireDatabricksConsultantDelhi />}
          />
          <Route
            path="/hire-databricks-consultant-gurugram"
            element={<HireDatabricksConsultantGurugram />}
          />

          <Route
            path="/hire-databricks-consultant-chennai"
            element={<HireDatabricksConsultantChennai />}
          />
          <Route
            path="/hire-databricks-consultant-gurgaon"
            element={<HireDatabricksConsultantGurgaon />}
          />
          <Route
            path="/hire-databricks-consultant-belgium"
            element={<HireDatabricksConsultantBelgium />}
          />
          <Route
            path="/hire-databricks-consultant-croatia"
            element={<HireDatabricksConsultantCroatia />}
          />
          <Route
            path="/hire-databricks-consultant-denmark"
            element={<HireDatabricksConsultantDenmark />}
          />
          <Route
            path="/hire-databricks-consultant-finland"
            element={<HireDatabricksConsultantFinland />}
          />

          <Route
            path="/hire-databricks-consultant-france"
            element={<HireDatabricksConsultantFrance />}
          />

          <Route
            path="/hire-databricks-consultant-germany"
            element={<HireDatabricksConsultantGermany />}
          />
          <Route
            path="/hire-databricks-consultant-greece"
            element={<HireDatabricksConsultantGreece />}
          />

          <Route
            path="/hire-databricks-consultant-hungary"
            element={<HireDatabricksConsultantHungary />}
          />
          <Route
            path="/hire-databricks-consultant-italy"
            element={<HireDatabricksConsultantItaly />}
          />

          <Route
            path="/hire-databricks-consultant-dubai"
            element={<HireDatabricksConsultantDubai />}
          />


          <Route
            path="/hire-databricks-consultant-sharjah"
            element={<HireDatabricksConsultantSharjah />}
          />

          <Route
            path="/hire-databricks-consultant-abu-dhabi"
            element={<HireDatabricksConsultantAbuDhabi />}
          />
          <Route
            path="/hire-databricks-consultant-saudi-arabia"
            element={<HireDatabricksConsultantSaudiArabia />}
          />

          <Route
            path="/hire-databricks-consultant-qatar"
            element={<HireDatabricksConsultantQatar />}
          />


          <Route
            path="/hire-databricks-consultant-kuwait"
            element={<HireDatabricksConsultantKuwait />}
          />
          <Route
            path="/hire-databricks-consultant-melbourne"
            element={<HireDatabricksConsultantMelbourne />}
          />
          <Route
            path="/hire-databricks-consultant-california"
            element={<HireDatabricksConsultantCalifornia />}
          />

          <Route
            path="/hire-databricks-consultant-dallas"
            element={<HireDatabricksConsultantDallas />}
          />
          <Route
            path="/hire-databricks-consultant-houston"
            element={<HireDatabricksConsultantHouston />}
          />

          <Route
            path="/hire-databricks-consultant-charlotte"
            element={<HireDatabricksConsultantCharlotte />}
          />

          <Route
            path="/hire-databricks-consultant-chicago"
            element={<HireDatabricksConsultantChicago />}
          />
          <Route
            path="/hire-databricks-consultant-atlanta"
            element={<HireDatabricksConsultantAtlanta />}
          />
          <Route
            path="/hire-databricks-consultant-phoenix"
            element={<HireDatabricksConsultantPhoenix />}
          />

          <Route
            path="/hire-databricks-consultant-boston"
            element={<HireDatabricksConsultantBoston />}
          />
          <Route
            path="/hire-databricks-consultant-philadelphia"
            element={<HireDatabricksConsultantPhiladelphia />}
          />
          <Route
            path="/hire-databricks-consultant-detroit"
            element={<HireDatabricksConsultantDetroit />}
          />



          <Route path="/servicenow-seo" element={<ServiceNowLinks />} />
          <Route path="/automation-and-ai-agents" element={<AutomationPage />} />
          <Route path="/data-ai-databricks-solution" element={<DataAiDatabricks />} />
          <Route path="/digital-engineering" element={<DigitalEngineering />} />

        </Routes>
        {!shouldHideHeaderFooter && <NewFooter />}
        <CookieConsent />
      </HelmetProvider>
    </>
  );
}

export default App;
